import React, { Component } from 'react';
import { auth } from '../../config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

class FirebaseTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      error: ''
    };
  }

  componentDidMount() {
    this.login();
  }

  login = () => {
    signInWithEmailAndPassword(auth, "putthidasamrith@gmail.com", "123456")
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        this.setState({ user: user });
        console.log('Successfully logged in user:', user);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        this.setState({ error: errorMessage });
      });
  }

  render() {
    const { user, error } = this.state;
    return (
      <>
        <div id="page-container" className="mx-auto flex min-h-dvh w-full min-w-[320px] flex-col bg-gray-100 dark:bg-gray-900 dark:text-gray-100">
          <p>Firebase Token</p>
          {user ? (
            <div>
              <h1>User Logged In</h1>
              <p><b>Email:</b> {user.email}</p><br/>
              <p><b>UID:</b> {user.uid}</p><br/>
              <p><b>Token:</b> {user.accessToken}</p><br/>
            </div>
          ) : (
            <p>No user logged in</p>
          )}
          {error && (
            <p>Error: {error}</p>
          )}
        </div>
      </>
    );
  }
}

export default FirebaseTest;
